export enum PriceValueVariant {
  normal = 'normal',
  small = 'small',
}
